import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add maintenance schedule API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  addMaintenanceSchedule: (data: any): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/facility/v1/maintenance-schedule`, data, false);
  },
  /**
   * Can existing schedules and add maintenance schedule API
   * @param data
   */
  cancelScheduleAndAddMaintenanceSchedule: (data: any): Promise<any> => {
    return postRequest(
      `${config.commonApiUrl}api/facility/v1/maintenance-schedule/cancel-and-create`,
      data,
      false,
    );
  },
  /**
   * Fetch maintenance schedule API
   * @param query
   */
  fetchMaintenanceSchedule: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/maintenance-schedule`, {
      ...parameters,
    });
  },
  /**
   * Fetch maintenance schedule API for export
   * @param query
   */
  fetchMaintenanceScheduleExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/maintenance-schedule/export-data`, {
      ...parameters,
    });
  },
  /**
   * Edit maintenance schedule API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editMaintenanceSchedule: (id: number | string | null, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/maintenance-schedule/${id}`,
      data,
      false,
    );
  },

  /**
   * Fetch report API
   * @returns
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/maintenance-schedule/list-filters`);
  },
};
